import { TenantCreateForm } from "@/tenant"
import { Golden, H1 } from "@/ui/components"
import { useT } from "@/i18n"

export default function OnboardingPage() {
  const { t } = useT("auth")

  return (
    <Golden className="h-screen">
      <H1>{t("nameWorkspace")}</H1>
      <div className="m-4 w-sm">
        <TenantCreateForm />
      </div>
    </Golden>
  )
}
